import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_konig.png",
      alt: "König",
    },
    title: "Lucre com a König",

    // String ou array de strings
    text: "Fundada em 2017, nossa empresa atua nos mais diversos segmentos do mercado com o objetivo único de maximizar os ganhos de nossos clientes. Com vasta experiência nos mercados de renda variável, nosso portfólio de automações entrega resultados excepcionais mês a mês, transformando realidades e vidas. ",
    testimonial: {
      text: "Nosso objetivo é mostrar que você pode ter qualidade de vida enquanto nossos robôs cuidam das suas finanças.",
      author: {
        name: "Samuel König - CEO König Investimentos",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias König",
    heading: "Transforme oportunidades em lucro com nossa tecnologia.",
    subtitle:
      "Utilizando tecnologia de última geração e a expertise dos melhores operadores, disponibilizamos algoritmos avançados para operar em sua conta. Com um simples clique, você alcança o nível de um profissional do mercado.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Prepare-se para operar como um expert.",
    buttonText: "Ativar Robôs",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "König",
    col1: [
      "Explore a inovação nos investimentos com nossa empresa, líder em tecnologia financeira. Fundada por Traders com mais de 10 anos de experiência, unimos inteligência artificial e expertise para criar os robôs mais avançados do mercado.",
      "Nossa equipe desenvolve algoritmos inteligentes que se ajustam em tempo real, garantindo resultados consistentes e lucrativos. ",
      "Junte-se a nós e descubra o impacto que a excelência tecnológica pode ter nos seus investimentos. ",
    ],
    col2: [
      // "De 2009 a 2014 desenvolvi um método de análise quantitativo, utilizando Estatística e Probabilidade. De 2015 a 2019, desenvolvi robôs na plataforma Metatrader. Em 2020, porém, minha visão do mercado mudaria de novo (para melhor), com a minha entrada no Mestrado em Ciência da Computação na Universidade Federal do Rio Grande do Sul (UFRGS). Lá aprendi a utilizar os algoritmos que hoje fazem parte deste produto: algoritmos de machine learning, uma área da inteligência artificial desenvolvida para resolver problemas de previsão.",
    ],
  },

  stats: {
    title: "Tenha o seu próprio exército de robôs guerreando por você",
    subtitle: "Viva e deixe seu exército pagar a conta!",
    data: [
      {
        value: "+7",
        description: "Anos de experiência",
      },
      {
        value: "+50",
        description: "Estratégias consolidadas",
      },
      {
        value: "+2k",
        description: "Teste de robustez em cada estratégia",
      },
    ],
  },

  // picture: {
  //   url: "https://ontick-img.s3.sa-east-1.amazonaws.com/nl_resultado.jpeg",
  //   description: "Algoritmo de Mini-índice x Ibovespa. Atualizado em 12 de setembro de 2022.",
  // },

  features: {
    title: "Por que utilizar os meus robôs?",
    subtitle: "Veja quais as principais vantagens.",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Você não precisa de conhecimento nenhum para operar como um profissional, basta ligar os algoritmos da König com um clique e o resto é com nosso time.",
      },
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Nossos algoritmos são pensados por profissionais e treinados por inteligências artificiais, usamos uma tecnologia de ponta para criar portifólios robustos e que se adaptam ao mercado. ",
      },
      {
        icon: iconsSet.favorite,
        title: "Zero emocional",
        description:
          "Com nossos algoritmos você não precisa se preocupar com nada, o maior motivo de prejuízo em operações é o emocional do Trader, aqui esse problema é banido. ",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Profissionais de verdade",
        description:
          "A König foi criada por operadores de renda variável do Institucional, isso mesmo profissionais que atuam no mercado criando e levando oportunidade para clientes do Brasil inteiro de forma profissional. ",
      },
      {
        icon: iconsSet.click,
        title: "Praticidade",
        description:
          "Nossos robôs estão prontos para operar em sua conta com um único clique. Eles funcionam de forma segura, são monitorados por profissionais e possuem um histórico impecável de desempenho. ",
      },
      {
        icon: iconsSet.money,
        title: "Futuro ",
        description:
          "Nossos produtos transformaram a vida de muitos clientes, auxiliando-os a compreender o mercado, gerar uma renda extra e até mesmo a sonhar com uma aposentadoria confortável ou uma vida muito melhor. ",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Descobri a Konig em um momento em que precisava de uma solução confiável para meus investimentos. A tecnologia avançada e o suporte da equipe fizeram uma grande diferença, tornando o processo muito mais simples e lucrativo para mim.",
      author: "Bryan Rogger",
      job: "Advogado",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Como alguém com uma agenda lotada e sem tempo para ficar analisando oportunidades de investimento o dia todo, a Konig foi uma verdadeira salvação. Seus robôs de negociação fazem todo o trabalho pesado por mim, permitindo que eu aproveite as oportunidades do mercado sem precisar estar preso à tela o tempo todo. Agora, posso investir de forma eficiente e ainda manter minha rotina sem estresse.",
      author: "Juliana Oliveira",
      job: "Arquiteta",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Escolha o plano mais adequado para você:",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
